import { render, staticRenderFns } from "./VeryBottom.vue?vue&type=template&id=39bd356e&"
import script from "./VeryBottom.vue?vue&type=script&lang=js&"
export * from "./VeryBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports